import React from 'react'
import ChangeData from './ChangeData'
import ChangeList from './ChangeList'

const ChangeBlock = ({ change }) => {
  return (
    <div className='changesBlock__one'>
        <ChangeData
            change={change}
        />
        <ChangeList 
            changesList={change.changesList}
        />
    </div>
  )
}

export default ChangeBlock